// REFACTORED: 2026-02-03
// Query-related constants - Cache times, stale times, retry configs, etc.

/**
 * Standard cache time for queries (5 minutes)
 */
export const CACHE_TIME = 5 * 60 * 1000; // 5 minutes

/**
 * Standard stale time for queries (5 minutes)
 */
export const STALE_TIME = 5 * 60 * 1000; // 5 minutes

/** Short cache: 2 minutes stale, 5 min gc (for frequently changing data) */
export const SHORT_CACHE_MS = 2 * 60 * 1000;
export const SHORT_GC_MS = 5 * 60 * 1000;

/** Medium cache: 5 minutes stale, 10 min gc (default for filters / options) */
export const MEDIUM_CACHE_MS = 5 * 60 * 1000;
export const MEDIUM_GC_MS = 10 * 60 * 1000;

/** Long cache: 15+ minutes (for rarely changing reference data) */
export const LONG_CACHE_MS = 15 * 60 * 1000;
export const LONG_GC_MS = 60 * 60 * 1000;

/**
 * Query options for /dashboard/sub-bus (Sub-BU options by Business Units).
 * Used by useSubBusOptions and any component that fetches sub-bus options.
 */
export const SUB_BU_QUERY_OPTIONS = {
  staleTime: MEDIUM_CACHE_MS,
  gcTime: MEDIUM_GC_MS,
  retry: 2,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
};

/**
 * Projects-specific query configurations
 */
export const PROJECTS_QUERY_CONFIG = {
  // Filter options query config
  filterOptions: {
    staleTime: 0, // TEMPORARY: No cache to debug delivery_bus issue
    gcTime: 30 * 60 * 1000, // 30 minutes - keep in memory much longer
    retry: 3,
    retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    refetchOnWindowFocus: true, // TEMPORARY: Refetch on window focus to debug
    refetchOnMount: true, // TEMPORARY: Always refetch to debug
    refetchOnReconnect: true,
  },
  
  // Sub-BU options query config
  subBuOptions: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  },
  
  // Projects dashboard query config
  dashboard: {
    staleTime: 2 * 60 * 1000, // 2 minutes - optimized for faster updates
    refetchOnWindowFocus: false,
  },
};


